<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
  Rediger adgangsgrupper
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

@let filteredAccessGroups = filteredAccessGroups$ | async;
<mat-dialog-content>
  <div class="form-row form-row--multi-select nolimits">
    <h2 class="form-headline margin--bottom-m">Adgangsgrupper</h2>

    <div class="multi-select margin--top-m">
      @if (!organizationContainsAccessGroups) {
        <em class="margin--bottom-m block"> Der er ingen adgangsgrupper at tilknytte </em>
      }

      <div class="multi-select__list">
        @if (organizationContainsAccessGroups) {
          <div class="multi-select__input">
            <div class="flex filter-dropdown" [formGroup]="accessGroupIdTagCreateModel">
              <mat-form-field>
                <mat-label>Vælg adgangsgruppe</mat-label>
                <div>
                  <input type="text" formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
                </div>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  hideSingleSelectionIndicator="true"
                  [displayWith]="accessGroupDisplayFn"
                  okCustomDropDownArrowDirective>
                  @for (accessGroup of filteredAccessGroups; track accessGroup) {
                    <mat-option [value]="accessGroup" class="access-group-item access-group-item--select flex">
                      <div class="access-group-item__name">{{ accessGroup.name }}</div>
                      <div class="flex flex-col">
                        <span class="access-group-item__extra-info">
                          <span>Organisation: </span>
                          {{ accessGroup.organizationName }}
                        </span>
                        <span class="access-group-item__extra-info">
                          <span>Rabat: </span>
                          @if (accessGroup.discountType === discountType.FixedAmount) {
                            {{ accessGroup.amount | dkCurrency }}
                          }
                          @if (accessGroup.discountType === discountType.Percentages) {
                            {{ accessGroup.amount | number: '1.2-2' }} %
                          }
                        </span>
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (accessGroupIdTagCreateModel.controls.typeAheadQuery.value) {
                  <mat-icon matSuffix class="clear-input-field-button" (click)="resetAccessGroup()"> close </mat-icon>
                }
                <mat-icon matSuffix></mat-icon>
              </mat-form-field>
              <button
                mat-flat-button
                title="Tilføj"
                (click)="saveAccessGroupToIdTag()"
                class="add-button margin--left-s"
                [disabled]="saving || accessGroupIdTagCreateModel.invalid || formGroup.invalid"
                [class.spinner]="saving">
                <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
              </button>
            </div>
          </div>
        }
        <div class="multi-select__items">
          @for (accessGroupIdTag of accessGroupIdTags$ | async; track accessGroupIdTag; let i = $index) {
            <div class="multi-select__item multi-select__item--tall">
              <div class="access-group-item flex">
                <div class="access-group-item__name">
                  Navn: <span>{{ accessGroupIdTag.name }}</span>
                </div>
                <div class="flex flex-col">
                  <span class="access-group-item__extra-info">
                    Rabat:
                    <span>
                      @if (accessGroupIdTag.discountType === discountType.FixedAmount) {
                        {{ accessGroupIdTag.amount | dkCurrency }}
                      }
                      @if (accessGroupIdTag.discountType === discountType.Percentages) {
                        {{ accessGroupIdTag.amount | number: '1.2-2' }} %
                      }
                    </span>
                  </span>
                </div>
                <button
                  mat-icon-button
                  class="delete"
                  title="Fjern"
                  type="button"
                  (click)="deleteAccessGroupIdTag(accessGroupIdTag.accessGroupIdentifier)">
                  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="unit-identifier">
    @if (idTag.printedId) {
      <span>Brik ID:</span>
    }
    @if (!idTag.printedId) {
      <span>Brik beskrivelse:</span>
    }
    {{ idTag.printedId ? idTag.printedId : idTag.description }}
  </div>
  <button type="button" mat-button mat-dialog-close (click)="close()">Luk</button>
</mat-dialog-actions>
